export default (text) => {
  return text;
};
